import { z } from "zod";

export const defaultRouteFormSchema = z.object({
  id: z.number(),
  name: z.string(),
  truck_id: z.string(),
  relations: z.array(z.number()).min(1),
  active: z.boolean().optional().nullable(),
});

export const truckNameSchema = z.object({
  id: z.number(),
  title: z.string(),
});
